import {AMATEUR_FILM_COMMENT_SUCCESS, AMATEUR_FILM_LIKE_SUCCESS} from './amateurFilm';

const GET_PROFILE_AMATEUR_FILMS_REQUEST = 'GET_PROFILE_AMATEUR_FILMS_REQUEST';
const GET_PROFILE_AMATEUR_FILMS_SUCCESS = 'GET_PROFILE_AMATEUR_FILMS_SUCCESS';
const GET_PROFILE_AMATEUR_FILMS_FAILURE = 'GET_PROFILE_AMATEUR_FILMS_FAILURE';

import * as backend from 'backend-helpers/profileAmateurFilms';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: null,
    online: null,
    amateurFilms: {
        list: [],
        totalCount: 0
    }
};

export default function profileAmateurFilms(state = initState, action) {
    if (action.type === GET_PROFILE_AMATEUR_FILMS_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    if (action.type === GET_PROFILE_AMATEUR_FILMS_FAILURE) {
        let {error, ...rest} = action;

        console.log('GET_PROFILE_AMATEUR_FILMS_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    if (action.type === AMATEUR_FILM_LIKE_SUCCESS) {
        return {
            ...state,
            amateurFilms: {
                ...state.amateurFilms,
                list: state.amateurFilms.list.map((item) => item.id === action.id ? {...item, is_liked: true, like_count: item.like_count + 1} : item)
            }

        }
    }

    if (action.type === AMATEUR_FILM_COMMENT_SUCCESS) {
        return {
            ...state,
            amateurFilms: {
                ...state.amateurFilms,
                list: state.amateurFilms.list.map((item) => item.id === action.id ? {...item, comment_count: item.comment_count + 1} : item)
            }

        }
    }

    return state;
}

export function getProfileAmateurFilms(nick, order) {
    return {
        types: [GET_PROFILE_AMATEUR_FILMS_REQUEST, GET_PROFILE_AMATEUR_FILMS_SUCCESS, GET_PROFILE_AMATEUR_FILMS_FAILURE],
        promise: backend.getProfileAmateurFilms(nick, order)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileAmateurFilms.js